const quickViewWrapper = document.getElementById("quickViewWrapper");
let lastQuickViewTrigger = null;

const closeQuickView = () => {
  if (!quickViewWrapper) return;

  document.body.classList.remove("overflow-hidden");
  quickViewWrapper.classList.remove("show__modal");
  quickViewWrapper.setAttribute("aria-hidden", "true");

  const triggerToRestore = lastQuickViewTrigger;
  if (triggerToRestore) {
    triggerToRestore.classList.remove("active");
    triggerToRestore.setAttribute("aria-expanded", "false");
  }

  if (typeof removeTrapFocus === "function") {
    removeTrapFocus(triggerToRestore);
  } else {
    triggerToRestore?.focus();
  }

  lastQuickViewTrigger = null;
};

if (quickViewWrapper) {
  quickViewWrapper.addEventListener("keyup", (event) => {
    if (event.code === "Escape") closeQuickView();
  });

  quickViewWrapper.addEventListener("click", (event) => {
    if (event.target === quickViewWrapper) closeQuickView();
  });
}

class QuickViewModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClickQuickViewModal);

    const trigger = this.querySelector("button[data-product-handle]");
    trigger?.setAttribute("aria-controls", "quickViewWrapper");
    trigger?.setAttribute("aria-expanded", "false");
  }

  onClickQuickViewModal = async (event) => {
    const quickViewTrigger = event.target.closest("button[data-product-handle]");
    if (!quickViewTrigger || !this.contains(quickViewTrigger) || !quickViewWrapper) return;
    if (quickViewTrigger.classList.contains("loading")) return;

    const productHandle = quickViewTrigger.dataset.productHandle;
    if (!productHandle) return;

    event.preventDefault();
    quickViewTrigger.classList.add("loading");
    quickViewTrigger.setAttribute("aria-busy", "true");

    try {
      const response = await fetch(`/products/${encodeURIComponent(productHandle)}?view=quickview`);
      if (!response.ok) throw new Error(`Quick view request failed: ${response.status}`);

      quickViewWrapper.innerHTML = await response.text();

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      lastQuickViewTrigger?.classList.remove("active");
      lastQuickViewTrigger?.setAttribute("aria-expanded", "false");
      lastQuickViewTrigger = quickViewTrigger;
      quickViewTrigger.classList.add("active");
      quickViewTrigger.setAttribute("aria-expanded", "true");

      document.body.classList.add("overflow-hidden");
      quickViewWrapper.setAttribute("aria-hidden", "false");
      quickViewWrapper.classList.add("show__modal");

      const focusTarget = quickViewWrapper.querySelector(".quick__view_btn_close") || quickViewWrapper;
      if (typeof trapFocus === "function") trapFocus(quickViewWrapper, focusTarget);
    } catch (error) {
      console.error(error);
    } finally {
      quickViewTrigger.classList.remove("loading");
      quickViewTrigger.removeAttribute("aria-busy");
    }
  };
}

if (!customElements.get("quick-view-modal")) {
  customElements.define("quick-view-modal", QuickViewModal);
}

class QuickViewCloseTag extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.quickViewClose);
  }

  quickViewClose(event) {
    event.preventDefault();
    closeQuickView();
  }
}

if (!customElements.get("quick-view-close")) {
  customElements.define("quick-view-close", QuickViewCloseTag);
}

class QuickVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.getPreOrderVariantData();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll(".product-form__input--dropdown")).map(
      (select, index) => {
        select.children[0].children[1].innerHTML = this.options[index];
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        //console.log(destination);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
     
        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("no-js-inline");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    //console.log(this.PreorderVariantData);

    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;
    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    // Preorder Button
    let productVarArray = this.PreorderVariantData;
    let variant = this.currentVariant;
    let VarInventoryManagement =
      this.currentVariant?.inventory_management ?? null;
    let var_num = "";
    if (VarInventoryManagement != null) {
      for (let variant_id in productVarArray) {
        if (variant.id == variant_id) {
          var_num = productVarArray[variant_id].qty;
          var inventoryQuantity = parseInt(var_num);
          var inventoryPolicy = productVarArray[variant_id].inventory_policy;
        }
        if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
          addButton.removeAttribute("disabled");
          addButton.textContent = window.variantStrings.preorder;
        } else if (inventoryQuantity <= 0 && inventoryPolicy !== "continue") {
          addButton.setAttribute("disabled", true);
          addButton.textContent = window.variantStrings.soldOut;
        } else {
          addButton.removeAttribute("disabled");
          addButton.textContent = window.variantStrings.addToCart;
        }
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant]").textContent);
    return this.variantData;
  }
  getPreOrderVariantData() {
    this.PreorderVariantData =
      this.PreorderVariantData ||
      JSON.parse(this.querySelector("[data-preorder]").textContent);
  }
}

customElements.define("quick-variant-selects", QuickVariantSelects);

class QuickVariantRadios extends QuickVariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateOptionsParent() {
    this.fieldsets.map((fieldset, index) => {
      fieldset.children[0].children[1].innerHTML = this.options[index];
    });
  }
}
customElements.define("quick-variant-radios", QuickVariantRadios);
